export const SET_STATUS="app/devices/SET_STATUS"
export const NEXT_PAGE="app/devices/NEXT_PAGE"
export const BACK_PAGE="app/devices/BACK_PAGE"
export const RESET_PAGE="app/devices/RESET_PAGE"
export const DEVICES_LOADING="app/devices/DEVICES_LOADING"
export const SET_SEARCH="app/devices/SET_SEARCH"
export const SET_SEARCH_VIEW="app/devices/SET_SEARCH_VIEW"
export const SET_TAGS="app/devices/SET_TAGS"
export const SET_AVAILABLE_TAGS_VIEW="app/devices/SET_AVAILABLE_TAGS_VIEW"
